import * as THREE from 'three';

interface MagicSpellEffectProps {
    position: THREE.Vector3;
    spellType: 'fire' | 'ice' | 'lightning';
    scale?: number;
}

// VFX disabled for runtime stability.
export const MagicSpellEffect = (_props: MagicSpellEffectProps) => null;

export const DeathExplosionEffect = (_props: Omit<MagicSpellEffectProps, 'spellType'>) => null;

export const SwordTrailEffect = (_props: Omit<MagicSpellEffectProps, 'spellType'>) => null;

export const AmbientEffect = (_props: Omit<MagicSpellEffectProps, 'spellType'>) => null;
